// src/components/dashboard/TeamNeurodiversityMap.jsx (エラー修正版)
import React from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';
import { BrainCircuit } from 'lucide-react';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="bg-white p-3 border rounded-lg shadow-lg">
        <p className="font-bold text-gray-800">{data.name}</p>
        <p className="text-sm text-gray-600">処理スタイル: {data.x.toFixed(1)}</p>
        <p className="text-sm text-gray-600">思考スタイル: {data.y.toFixed(1)}</p>
        <p className="text-sm text-gray-600">注意パターン: {data.z.toFixed(1)}</p>
      </div>
    );
  }
  return null;
};

const TeamNeurodiversityMap = ({ userProfiles }) => {
  // ▼▼▼ データが存在しない、または空の場合にクラッシュするのを防ぐ ▼▼▼
  if (!userProfiles || Object.keys(userProfiles).length === 0) {
    return (
      <div className="h-full flex items-center justify-center">
        <p className="text-gray-500">分析対象のユーザーデータがありません。</p>
      </div>
    );
  }

  const chartData = Object.values(userProfiles)
    // ▼▼▼ neurodiversityProfile自体が存在しない場合も考慮 ▼▼▼
    .filter(p => p && p.neurodiversityProfile && p.role !== 'master')
    .map(p => ({
      name: p.username,
      x: p.neurodiversityProfile.processingStyle?.value || 50,
      y: p.neurodiversityProfile.thinkingStyle?.value || 50,
      z: p.neurodiversityProfile.attentionPattern?.value || 50,
    }));

  if (chartData.length === 0) {
    return (
       <div className="h-full flex items-center justify-center">
        <p className="text-gray-500">表示できる認知多様性データを持つメンバーがいません。</p>
      </div>
    )
  }

  return (
    <div style={{ width: '100%', height: 400 }}>
      <ResponsiveContainer>
        <ScatterChart margin={{ top: 20, right: 20, bottom: 40, left: 20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" dataKey="x" name="処理スタイル" unit="" domain={[0, 100]}>
            <Label value="逐次的 ↔ 全体的" offset={-25} position="insideBottom" />
          </XAxis>
          <YAxis type="number" dataKey="y" name="思考スタイル" unit="" domain={[0, 100]}>
             <Label value="収束的 ↔ 発散的" angle={-90} position="insideLeft" style={{ textAnchor: 'middle' }} />
          </YAxis>
          <ZAxis type="number" dataKey="z" name="注意パターン" range={[60, 400]} />
          <Tooltip content={<CustomTooltip />} cursor={{ strokeDasharray: '3 3' }} />
          <Scatter name="Team" data={chartData} fill="#8884d8" />
        </ScatterChart>
      </ResponsiveContainer>
      <p className="text-xs text-center text-gray-500 mt-2">
        ※ X軸: 情報処理 (左:逐次的/右:全体的) | Y軸: 思考 (下:収束的/上:発散的) | 点の大きさ: 注意パターン
      </p>
    </div>
  );
};

export default TeamNeurodiversityMap;
